import { trackingService } from '../../tracking';
import { TrackerType } from '../enums';
import { PRODUCT_NAME, PARTNER_ID } from './constants';

export const trackInviteAssistantPageView = (userId?: string): void => {
  trackingService.trackEvent(
    'INVITE',
    PRODUCT_NAME,
    {
      page: 'ajuda',
      route: '/inicio/tutorial',
      placement: '',
      surface: '',
      flow: 'assistente',
      step: 'inicio',
      element: '',
      action: 'view',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackInviteAssistantClick = (userId?: string): void => {
  trackingService.trackEvent(
    'INVITE',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'side menu',
      surface: 'list',
      flow: 'assistente',
      step: 'convidar',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};
